<div class="back-dialog-background"></div>
<div class="back-dialog-container">
  <div class="back-dialog-top-container">
    <div class="focus-dialog-subtext-container">
      <p class="font-24">
        If you leave now, you will have to start the task over next time.
      </p>
      <p class="font-24">
        Are you sure you want to leave?
      </p>
    </div>
  </div>
  <div class="back-dialog-bottom-container">
    <button class="back-dialog-btn confirm-btn" (click)="onConfirmClick()">
      <span class="back-confirm-text font-30">Yes</span>
    </button>
    <button class="back-dialog-btn cancel-btn" (click)="onCancelClick()">
      <span class="back-cancel-text font-30">No</span>
    </button>
  </div>
</div>
